import { DropdownMenu, DropdownSearch, Filters } from '@keplerco/core';
import React, { PropsWithChildren, useEffect } from 'react';
import { FilteringSearchParams } from '../../../models/overmind/search-params';
import { IAnalyticsFiltersProps } from './analytics-filters.models';

export function AnalyticsFilters({ departmentOptions, teamOptions, roleOptions, skillOptions, countryOptions, statusOptions, filteringSearchParams, setFilteringSearchParams, applyFilters, clearFilters, children }: PropsWithChildren<IAnalyticsFiltersProps>): React.ReactElement {
  const [isActive, setIsActive] = React.useState(false);

  useEffect(() => {
    if (filteringSearchParams) {
      setIsActive(
        !!filteringSearchParams.departmentSlugs?.length || !!filteringSearchParams.teamSlugs?.length || !!filteringSearchParams.roleSlugs?.length || !!filteringSearchParams.skillSlugs?.length || !!filteringSearchParams.countryIds?.length || !!filteringSearchParams.completionStatus?.length
      );
    }
  }, [filteringSearchParams]);

  async function updateFilteringSearchParams(filter: keyof FilteringSearchParams, value: string) {
    const currentRequest = structuredClone(filteringSearchParams);
    const newValue: string | string[] = value.includes(',') ? value.split(',') : value;

    if (JSON.stringify(currentRequest[filter]) === JSON.stringify(newValue)) return;

    const newRequest = {
      ...currentRequest,
      [filter]: newValue,
    };
    setFilteringSearchParams(newRequest);
  }

  return (
    // Ensures that the filters button doesn't stretch on mobile
    <div>
      <Filters isActive={isActive} onClickClear={clearFilters} onClickApply={applyFilters}>
        {!!departmentOptions && <DropdownSearch label="Departments" options={departmentOptions} value={filteringSearchParams.departmentSlugs} multiple onChange={event => updateFilteringSearchParams('departmentSlugs', event.target.value)} dialogContained />}

        {!!teamOptions && <DropdownSearch label="Teams" options={teamOptions} value={filteringSearchParams.teamSlugs} multiple onChange={event => updateFilteringSearchParams('teamSlugs', event.target.value)} dialogContained />}

        {!!roleOptions && <DropdownSearch label="Roles" options={roleOptions} value={filteringSearchParams.roleSlugs} multiple onChange={event => updateFilteringSearchParams('roleSlugs', event.target.value)} dialogContained />}

        {!!skillOptions && <DropdownSearch label="Skills" options={skillOptions} value={filteringSearchParams.skillSlugs} multiple onChange={event => updateFilteringSearchParams('skillSlugs', event.target.value)} dialogContained />}

        {!!countryOptions && <DropdownSearch label="Countries" options={countryOptions} value={filteringSearchParams.countryIds} multiple onChange={event => updateFilteringSearchParams('countryIds', event.target.value)} dialogContained />}

        {!!statusOptions && <DropdownMenu label="Status" options={statusOptions} value={filteringSearchParams.completionStatus} multiple onChange={event => updateFilteringSearchParams('completionStatus', event.target.value)} dialogContained />}

        {children}
      </Filters>
    </div>
  );
}
